import styled from 'styled-components';

export const Topic = styled.p`
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: 0.2px;
  margin: 0;
`;

export const StepTitle = styled.p`
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${({ theme }) => theme.historyProviderColor};
`;

export const Title = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.textTertiary};
`;

export const Label = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  color: ${({ theme }) => theme.textPrimary};
`;

export const Description = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: ${({ theme }) => theme.textPrimary};
`;

export const Text = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: ${({ theme }) => theme.textPrimary};
`;

export const BigTitleBold = styled.p`
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  color: ${({ color = 'textPrimary', theme }) =>
    theme[color] || theme.textPrimary};
`;

export const LargeBodyRegular = styled.p`
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: ${({ color = 'textPrimary', theme }) =>
    theme[color] || theme.textPrimary};
`;
